module.exports = __webpack_public_path__ + "img/mercado-pago.89e6a52f.svg";